import axios from "axios";
import { toast } from "react-toastify";

function authHeader() {
    const token = localStorage.getItem("token");
    if (token) {
        return {
            'x-access-token': token,
            'Content-Type': 'application/json'
        };
    } else {
        return {
            'Content-Type': 'application/json'
        };
    }
}
export const baseURL = process.env.REACT_APP_API_URL || "https://api-flashcard-dev.h2-inc.com";
// export const baseURL = "http://localhost:3000";
const instanceAxios = axios.create({
    baseURL,
    headers: authHeader()
});

if (localStorage.getItem("token")) {
    instanceAxios.get("/users/checkToken").then().catch(err => {
        toast.warning("Your JWT token has expired. Please log in again!")
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        window.location.reload();
    });
}

instanceAxios.interceptors.request.use(
    async (config) => {
        if (config.url === "/users/checkToken") {
            return config;
        }
        if (localStorage.getItem("token")) {
            try {
                await instanceAxios.get("/users/checkToken");
            } catch (err) {
                toast.warning("Your JWT token has expired. Please log in again!")
                localStorage.removeItem("token");
                localStorage.removeItem("user");
                setTimeout(() => {
                    window.location.reload();
                }, 1500);
            }
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default instanceAxios;

